import { buildParams } from '../../helpers/path';
import { CustomCacheRequest } from '../../types/props';
import { EmployeeType } from './employees-api';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type StatementStatusType = 'APPROVED' | 'REJECTED' | 'IDLE';
export type StatementTypeType = 'VACATION' | 'SICK';

export type StatementType = {
  id: number;
  staff: Pick<EmployeeType, 'id' | 'name' | 'surname' | 'tags'>;
  start_date: string;
  end_date: string;
  comment: string;
  manager_comment: string;
  created_at: string;
  updated_at: string;
  status: StatementStatusType;
  type: StatementTypeType;
};

export type FetchStatementListRequest = CustomCacheRequest & {
  n: number;
  since_id: number;
  is_by_company: boolean;
};

const baseUrl = `${managerApiUrl}/statement`;

export const fetchStatementList = async (
  request: Partial<FetchStatementListRequest>,
): Promise<StatementType[]> => {
  const { customCache, ...other } = request;

  const response = await baseFetch(baseUrl + buildParams(other), {
    customCache,
  });

  return response?.statements;
};

export type UpdateStatementStatusRequest = {
  id: number;
  status: StatementStatusType;
  manager_comment?: string;
};

export const updateStatementStatus = async (request: UpdateStatementStatusRequest) => {
  const { id, status, manager_comment } = request;

  await baseFetch(`${baseUrl}/${id}/change-status`, {
    method: 'PUT',
    body: JSON.stringify({ status, manager_comment: manager_comment || '' }),
  });
};
